import { darkTheme } from './theme';
import { ThemeType } from './themeType';

/**
 * Login / Amplify Authenticator always uses the dark palette, independent of
 * the app's light/dark toggle (stored preference must not affect the login page).
 */
export const loginTheme: ThemeType = darkTheme;
